<template>
  <div>
    <div class="vs-component vs-con-input-label w-full vs-input mb-1 vs-input-primary">
      <vs-row class="vx-row">
        <vs-col vs-w="3">
          <VueCtkDateTimePicker no-button-now label="Select Start Date" format="YYYY-MM-DD HH:mm" :min-date="minStart"
            :max-date="maxStart" v-model="dateStart" />
        </vs-col>
        <vs-col vs-w="3">
          <VueCtkDateTimePicker no-button-now label="Select End Date" format="YYYY-MM-DD HH:mm" :min-date="dateStart"
            :max-date="maxEnd" v-model="dateEnd" />
        </vs-col>
        <vs-col vs-w="3">
          <vs-select class="" v-model="channelId" placeholder="Channel">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in channelList" />
          </vs-select>
        </vs-col>
        <vs-col vs-w="3">
          <vs-button @click="GetPlaybackList">
            Get Playback List
          </vs-button>
        </vs-col>
      </vs-row>
    </div>
    <div class="overviews-cont vs-con-loading__container" style="max-height: 100%">
      <div style="max-height: 747px; overflow-y: scroll; overflow-x: hidden">
        <div v-if="showedList.length == 0" class="flex items-center justify-center" style="height: 600px">
          No Playback
        </div>
        <div v-else v-for="(tr, indextr) in showedList" :key="indextr" class="shadow overviewbg"
          style="padding: 10px 0; margin: 10px 0; border-radius: 8px">
          <vs-row vs-w="12">
            <vs-col vs-justify="center" vs-align="center" vs-xs="1" vs-lg="1" vs-md="1" vs-sm="1"
              style="position: relative">
              <div style="
                  background: #42aeef;
                  border-radius: 50%;
                  width: 50px;
                  height: 50px;
                  top: 50%;
                  transform: translateY(-50%);
                  position: absolute;
                ">
              </div>
            </vs-col>
            <vs-col vs-xs="11" vs-lg="11" vs-md="11" vs-sm="11">
              <h5 style="
                  color: #000000;
                  border-radius: 0 10px;
                  padding: 3px 22px;
                  margin-right: -16px;
                  margin-top: -10px;
                  background: #f2cd30;
                ">
                {{ tr.deviceName }}
              </h5>
              <vs-row vs-w="12">
                <vs-col vs-xs="10" vs-lg="10" vs-md="10" vs-sm="10" style="padding: 0">
                  <div class="product-name font-medium" style="display: flex">
                    <div class="float-left pl-1">
                      {{ tr.startTime }} - {{ tr.endTime }} WIB
                    </div>
                  </div>
                </vs-col>
                <vs-col vs-xs="2" vs-lg="2" vs-md="2" vs-sm="2" style="padding: 0">
                  <div class="product-name font-medium" style="display: flex">
                    <vs-button v-if="camType === 'STONKAM'" radius class="mt-2" color="danger" type="border"
                      icon="videocam" @click="getPlaybackAlarm(tr)"></vs-button>
                    <div v-else class="flex mt-2">
                      <vs-button radius class="mr-2" color="danger" type="border" icon="videocam"
                        @click="clickPlayblackReplay(tr, indextr)"></vs-button>
                      <vs-button radius class="ml-2" color="danger" type="border" icon="file_download"
                        @click="clickPlayblackDownload(tr)"></vs-button>
                    </div>
                  </div>
                </vs-col>

                <div class="w-full p-5" v-if="isShow[indextr]">
                  <div style="" class="flex justify-center">
                    <video :id="`playback-video-${indextr}`" class="w-full" type="video/mp4" controls
                      style="position: relative; z-index: 99">
                    </video>
                  </div>
                </div>
              </vs-row>
            </vs-col>
          </vs-row>
        </div>
        <vs-popup class="holamundo" title="Playback" :active.sync="popupActivo">
          <div class="flex flex-row">
            <!-- list of video channel -->
            <div class="flex flex-row flex-wrap" v-if="data.length > 0" v-for="(obj, index) in data">
              <vs-button :key="index" @click="download_data(obj)" class="m-1">
                Download Video {{ index + 1 }}
              </vs-button>
            </div>
            <div v-if="data.length == 0">
              <p>No video available</p>
            </div>
          </div>

        </vs-popup>
      </div>
    </div>
  </div>
</template>

<script>
import FlvJs from 'flv.js'
import moment from 'moment'
import * as REPO from '../../repository/index'

export default {
  name: 'MonitoringAlertCamera',
  props: {
    license_plate: String,
    dashcam: String,
  },
  data() {
    return {
      overview: [],
      event_type: '',
      event_list: [],
      deviceId: '',
      channelId: 1,
      channelList: '',
      camType: 'STONKAM',
      popupActivo: false,
      flvPlayer: null,
      status: 'loading',
      data: [],
      activeVideoChannel: 0,
      dateStart: moment().startOf('day').format('YYYY-MM-DD HH:mm'),
      dateEnd: moment().endOf('day').format('YYYY-MM-DD HH:mm'),
      minStart: moment()
        .subtract(27, 'days')
        .startOf('day')
        .format('YYYY-MM-DD HH:mm'),
      maxStart: moment().endOf('day').format('YYYY-MM-DD HH:mm'),
      maxEnd: moment().endOf('day').format('YYYY-MM-DD HH:mm'),
      isShow: [],
    }
  },
  computed: {
    getSelectValue(value, list) {
      return list.find((x) => x.value === value)
    },
  },
  created() {
    const dc = JSON.parse(this.dashcam)
    //
    this.camType = dc.type
    this.deviceId = dc.device_id
    this.channelList = dc.channels

    this.channelList = this.channelList.map((x) => {
      return {
        text: "Channel " + (x + 1),
        value: x + 1,
      }
    })
  },
  computed: {
    showedList() {
      return this.overview
    },
  },
  watch: {
  },
  mounted() {
    //
    this.getData()
    // distraction, seatbelt, fatigue, call, smoking, yawn
  },
  methods: {
    GetPlaybackList() {
      this.overview = []
      this.getData()
    },
    clickPlayblackReplay(tr, index) {
      this.$set(this.isShow, index, !this.isShow[index]);
      console.log(this.isShow, index, !this.isShow[index]);
      if (this.isShow[index]) {
        this.GetDataPlayblackReplay(tr, index)
      }
    },
    async clickPlayblackDownload(tr, index) {
      const token = await REPO.getMettaXToken().then((res) => {
        //
        return res.data.data
      })

      const body = {
        deviceId: this.deviceId,
        channelId: this.channelId,
        startTime: tr.startTime,
        endTime: tr.endTime,
        fastForwardOrBackward: "1",
        playbackType: "0",
        nodeValue: "singapore-1"
      }

      const res = await REPO.mettaXPlayback(token, body).then((res) => {
        if (res.data.msg == "device offline") {
          return this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: res.data.msg,
            position: 'top-right',
          })
        }

        return res.data.data
      })

      window.open(res, '_blank')
    },
    async GetDataPlayblackReplay(tr, index) {
      const videoElements = {};
      const token = await REPO.getMettaXToken().then((res) => {
        //
        return res.data.data
      })

      const body = {
        deviceId: this.deviceId,
        channelId: this.channelId,
        startTime: tr.startTime,
        endTime: tr.endTime,
        fastForwardOrBackward: "1",
        playbackType: "0",
        nodeValue: "singapore-1"
      }

      const res = await REPO.mettaXPlayback(token, body).then((res) => {
        if (res.data.msg == "device offline") {
          return this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: res.data.msg,
            position: 'top-right',
          })
        }

        return res.data.data
      })

      if (FlvJs.isSupported()) {
        videoElements[`${index}`] = document.getElementById(`playback-video-${index}`);
        var flvPlayer = FlvJs.createPlayer({
          type: 'flv',
          url: res,
          hasAudio: false,
          hasVideo: true,
        }, {
          enableStashBuffer: false,
        });
        flvPlayer.attachMediaElement(videoElements[`${index}`]);
        flvPlayer.load();
        flvPlayer.play();
      }

      console.log('play')

    },
    download_data(obj) {
      //
      const url = `https://api-camera-file.treffix.id/DownloadRecordFile.php?User=ttp-treffix&SessionId=1071&FileId=${obj.FileId}`

      window.open(url, '_blank')
    },
    getPlaybackAlarm(tr) {
      if (this.camType === 'STONKAM') {
        this.popupActivo = true

        const body = {
          UserName: 'ttp-treffix',
          DeviceId: this.deviceId,
          AlarmId: tr.id,
          SessionId: 1071,
        }


        REPO.testGetRecordByAlarmId(this.deviceId, body)
          .then((res) => {
            this.data = res.data.RecordFileList
            //
            // if (this.data.length < 2) {
            //   this.status = 'error'
            // } else {
            //   // this.startVideo(this.data[0].FileName)
            //   // this.activeVideoChannel = 0
            // }
          })
          .catch((err) => {
            console.error(err)
          })
      } else {
        const fileName = `test.mp4`
        this.download(tr.fileUrl, fileName)
      }
    },
    download(dataurl, filename) {
      const link = document.createElement('a')
      link.target = '_blank'
      link.href = dataurl
      link.download = filename
      link.click()
    },
    startVideo(filename) {
      const videoElement = document.getElementById(`live-video`)
      const tmpUrl = 'http://Playback-camera.treffix.id'
      const url = `${tmpUrl}/PlaybackDevice/${filename}?DeviceId=${this.deviceId}&TimeOffset=0&UserName=ttp-treffix&SessionId=1071`
      //

      this.flvPlayer = FlvJs.createPlayer(
        {
          type: 'flv',
          isLive: true,
          hasAudio: false,
          hasVideo: true,
          // url: `http://35.198.202.131:8082/OpenDeviceStream/100?DeviceId=${this.deviceId}&ChannelId=${obj.value}&RealTime=1&SessionId=1071`,
          url: url,
        },
        {
          enableStashBuffer: false,
        }
      )
      this.flvPlayer.attachMediaElement(videoElement)
      this.flvPlayer.on(FlvJs.Events.LOADING_COMPLETE, () => {
        // isOnline = true
        // this.loadingStop('#video-container')
      })
      this.flvPlayer.on(FlvJs.Events.ERROR, (errType, errDetail) => {
        console.error('FLV Error:', errType, errDetail)
        // status = 'error'
        // isOnline = false
        // this.reloadVideo()
      })
      this.flvPlayer.load()
      this.flvPlayer.play()
    },
    destroyVideo() {
      if (this.status !== 'error') {
        this.flvPlayer.pause()
        this.flvPlayer.unload()
        this.flvPlayer.detachMediaElement()
        this.flvPlayer.destroy()
        this.flvPlayer = null
      }
      this.status = 'loading'
    },
    async getData() {
      const self = this

      if (this.camType === 'STONKAM') {
        const sessionId = 1071
        const beginTime = moment(this.dateStart).format('YYYY~MM~DD~HH~mm~ss')
        const endTime = moment(this.dateEnd).format('YYYY~MM~DD~HH~mm~ss')

        const body = {
          DeviceId: self.deviceId,
          SessionId: sessionId,
          BeginTime: beginTime,
          EndTime: endTime,
          AlarmType: self.event_type,
        }

        try {
          const res = await REPO.getMonitoringAlertCamera(body)
          const resData = res.data.AlarmHisotryData

          self.overview = resData
            .map((x) => {
              const alarmType = self.event_list.find((y) => y.value === x.tp)
              return {
                ...x,
                normal_time: moment(x.tm)
                  .add(7, 'hours')
                  .format('YYYY-MM-DD HH:mm:ss'),
                event_type: alarmType ? alarmType.text : 'Unknown',
                address: null, // Initialize with null to show the loader
              }
            })
            .filter((x) => x.event_type !== 'Unknown')

          // Fetch addresses after initializing the overview data
          // for (let i = 0; i < self.overview.length; i++) {
          //   if (!self.overview[i].address) {
          //     const address = await self.getAddress(
          //       self.overview[i].lat,
          //       self.overview[i].lng
          //     )
          //     self.$set(self.overview[i], 'address', address.display_name)
          //   }
          // }
        } catch (err) { }
      } else {
        const token = await REPO.getMettaXToken().then((res) => {
          //
          return res.data.data
        })

        //

        const body = {
          deviceId: this.deviceId,
          channelId: this.channelId,
          startTime: moment(self.dateStart).format('yyyy-MM-DD HH:mm:ss'),
          endTime: moment(self.dateEnd).format('yyyy-MM-DD HH:mm:ss'),
        }

        const res = await REPO.mettaXPlaybackList(token, body).then((res) => {
          if (res.data.msg == "device offline") {
            return this.$vs.notify({
              color: 'danger',
              title: 'Error',
              text: res.data.msg,
              position: 'top-right',
            })
          }

          return res.data.data
        })

        self.overview = res
        //
        //   'res:',
        //   res.filter((x) => x.fileType == '02')
        // )
      }
    },
    async getAddress(latitude, longitude) {
      try {
        const body = {
          lat: latitude,
          lon: longitude,
        }
        const response = await REPO.getAddress(body)
        return response.data || { display_name: 'Unknown Address' }
      } catch (error) {
        console.error('Error fetching address:', error)
        return { display_name: 'Unknown Address' }
      }
    },
  },
}
</script>

<style lang="scss">
.datetimepicker>.flex {
  display: none !important;
}

.visible>.flex {
  display: block !important;
  left: 0;
}

.date-popup>.vs-popup>.vs-popup--content {
  overflow: visible;
}
</style>
